document.addEventListener('DOMContentLoaded', function() {
  const rotatingTextElement = document.querySelector('.rotating-text');
  if (rotatingTextElement) {
    const wordsString = rotatingTextElement.getAttribute('data-words');
    if (wordsString) {
      const words = wordsString.split(',').map(word => word.trim()).filter(word => word.length > 0);
      
      if (words.length > 1) {
        let currentIndex = 0;
        
        function rotateText() {
          rotatingTextElement.style.opacity = '0';
          
          setTimeout(() => {
            currentIndex = (currentIndex + 1) % words.length;
            rotatingTextElement.textContent = words[currentIndex];
            rotatingTextElement.style.opacity = '1';
          }, 300);
        }
        
        // Change word every 1.5 seconds
        setInterval(rotateText, 1500);
      }
    }
  }
});
